import { supabase } from '../lib/supabase';

const toCamel = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toCamel);
  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, l) => l?.toUpperCase());
    acc[camelKey] = toCamel(obj?.[key]);
    return acc;
  }, {});
};

export const quickAnswerService = {
  async getAll(companyId, fieldTarget = null) {
    try {
      let query = supabase?.from('reception_quick_answers')?.select('*')?.eq('active', true)?.order('sort_order');
      if (companyId) {
        query = supabase?.from('reception_quick_answers')?.select('*')?.or(`company_id.eq.${companyId},company_id.is.null`)?.eq('active', true)?.order('sort_order');
      }
      if (fieldTarget) {
        // We'll filter client-side to keep query simple
      }
      const { data, error } = await query;
      if (error) { console.error('Error fetching quick answers:', error); return []; }
      const results = (data || [])?.map(toCamel);
      return fieldTarget ? results?.filter(r => r?.fieldTarget === fieldTarget) : results;
    } catch (err) {
      console.error('Failed to fetch quick answers:', err);
      return [];
    }
  },

  async create(answerData) {
    try {
      const payload = {
        company_id: answerData?.companyId || null,
        label: answerData?.label,
        value: answerData?.value,
        field_target: answerData?.fieldTarget || 'motivo_visita',
        sort_order: answerData?.sortOrder || 0,
        active: true
      };
      const { data, error } = await supabase?.from('reception_quick_answers')?.insert(payload)?.select()?.single();
      if (error) throw error;
      return toCamel(data);
    } catch (err) {
      console.error('Failed to create quick answer:', err);
      throw err;
    }
  },

  async update(id, updateData) {
    try {
      const payload = {};
      if (updateData?.label !== undefined) payload.label = updateData?.label;
      if (updateData?.value !== undefined) payload.value = updateData?.value;
      if (updateData?.fieldTarget !== undefined) payload.field_target = updateData?.fieldTarget;
      if (updateData?.sortOrder !== undefined) payload.sort_order = updateData?.sortOrder;
      if (updateData?.active !== undefined) payload.active = updateData?.active;
      const { data, error } = await supabase?.from('reception_quick_answers')?.update(payload)?.eq('id', id)?.select()?.single();
      if (error) throw error;
      return toCamel(data);
    } catch (err) {
      console.error('Failed to update quick answer:', err);
      throw err;
    }
  },

  async delete(id) {
    try {
      const { error } = await supabase?.from('reception_quick_answers')?.update({ active: false })?.eq('id', id);
      if (error) throw error;
    } catch (err) {
      console.error('Failed to delete quick answer:', err);
      throw err;
    }
  }
};
